module.exports = __webpack_public_path__ + "img/02—01—03—DynDNS.918f9055.jpg";